import Login from '../pages/Login';
import Home from '../pages/Home';
import Detail from '../pages/Detail';
import Menu from '../pages/Menu';
import Pet from '../pages/Pet';
import Rank from '../pages/Rank';
import Record from '../pages/Record';
import PersonCenter from '../pages/PersonCenter';
import Edit from '../pages/PersonCenter/Edit';
import ParentHelp from '../pages/ParentHelp';
import FoodList from '../pages/Pet/FoodList';
import ForgotPassword from '../pages/ForgotPassword';
import Register from '../pages/Register';
import CoinRecord from '../pages/Pet/CoinRecord';
import PetRecord from '../pages/Pet/PetRecord';
import Download from '../pages/Download';
import Checkin from '../pages/Checkin';
import DailyTask from '../pages/DailyTask';
import Honors from '../pages/Honors';
import Yingshi from '../pages/Yingshi';
import Welcome from '../pages/Welcome';
import Mall from '../pages/Mall';
import MallProductDetail from '../pages/Mall/ProductDetail';
import TestTreasure from '../pages/TestTreasure';
import About from '../pages/About';

// 直接使用 Detail 组件，由组件内部处理关卡切换
// 避免 key 变化导致新旧组件同时存在，造成 DOM 翻倍

const routes = [
  { path: '/', element: <Login /> },
  { path: 'about/*', element: <About /> },
  { path: 'login', element: <Login /> },
  { path: 'home', element: <Home /> },
  { path: 'welcome', element: <Welcome /> },
  { path: 'menu', element: <Menu /> },
  { path: 'detail', element: <Detail /> },
  { path: 'pet', element: <Pet /> },
  { path: 'rank', element: <Rank /> },
  { path: 'record', element: <Record /> },
  { path: 'personCenter', element: <PersonCenter /> },
  { path: 'personCenterEdit', element: <Edit /> },
  { path: 'parentHelp', element: <ParentHelp /> },
  { path: 'coinRecord', element: <CoinRecord /> },
  { path: 'petRecord', element: <PetRecord /> },
  { path: 'forgotPassword', element: <ForgotPassword /> },  
  { path: 'register', element: <Register /> },
  { path: 'foodList', element: <FoodList /> },
  { path: 'download', element: <Download /> },
  { path: 'checkin', element: <Checkin /> },
  { path: 'daily-task', element: <DailyTask /> },
  { path: 'honors', element: <Honors /> },
  { path: 'yingshi', element: <Yingshi /> },
  // 商城（无需登录）
  { path: 'mall', element: <Mall /> },
  { path: 'mall/product/:id', element: <MallProductDetail /> },
  // 宝箱弹窗调试（仅 UI 预览）
  { path: 'test-treasure', element: <TestTreasure /> },
];

export default routes;